// extracted by mini-css-extract-plugin
module.exports = {"wishCloudButton":"WishCloudButton_wishCloudButton__BvjXe","wishCloudIcon":"WishCloudButton_wishCloudIcon__ab0a3"};